/* eslint-disable max-len */
import React from "react";

export default function iconBasket() {
  return (
    <svg
      className="icon basket"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
    >
      <path d="M 15 1 C 14.74425 1 14.488469 1.0974687 14.292969 1.2929688 L 7.5859375 8 L 10.414062 8 L 15 3.4140625 L 19.585938 8 L 22.414062 8 L 15.707031 1.2929688 C 15.511531 1.0974687 15.25575 1 15 1 z M 3 10 C 2.448 10 2 10.448 2 11 L 2 13 C 2 13.552 2.448 14 3 14 L 3.1660156 14 L 4.7207031 23.328125 C 4.8817031 24.292125 5.7163594 25 6.6933594 25 L 23.304688 25 C 24.282688 25 25.116344 24.292125 25.277344 23.328125 L 26.833984 14 L 27 14 C 27.552 14 28 13.552 28 13 L 28 11 C 28 10.448 27.552 10 27 10 L 3 10 z M 11 14 C 11.553 14 12 14.447 12 15 L 12 21 C 12 21.553 11.553 22 11 22 C 10.447 22 10 21.553 10 21 L 10 15 C 10 14.447 10.447 14 11 14 z M 15 14 C 15.553 14 16 14.447 16 15 L 16 21 C 16 21.553 15.553 22 15 22 C 14.447 22 14 21.553 14 21 L 14 15 C 14 14.447 14.447 14 15 14 z M 19 14 C 19.553 14 20 14.447 20 15 L 20 21 C 20 21.553 19.553 22 19 22 C 18.447 22 18 21.553 18 21 L 18 15 C 18 14.447 18.447 14 19 14 z" />
    </svg>
  );
}
